import PropTypes from "prop-types";
import React from "react";
import { Controller } from "react-hook-form";
import { Label } from "reactstrap";
import HubDeliverySelect from "../HubDeliverySelect";
import MessageFormValidateV2 from "../MessageFormValidateV2";

/**
 * @param {object} props
 * @param {object} props.mainForm
 * @param {string} props.fieldName
 * @param {function} props.t
 * @param {boolean} props.isDisabled
 * @param {boolean} props.isRequired
 * @param {boolean} props.isMultiple
 * @param {?function} props.onChange
 * @param {string} props.title
 * @param {boolean} props.isLabel
 * @param {boolean} props.isError
 * @param {boolean} props.isClearable
 * @param {any} props.idDefault
 * @param {any} props.paramsColumnFilter
 */
const FormHubDeliverySelect = props => {
  const {
    mainForm,
    fieldName,
    t,
    isDisabled,
    isRequired,
    isMultiple,
    onChange,
    title,
    isLabel,
    isError,
    isClearable,
    idDefault,
    paramsColumnFilter,
  } = props;

  const {
    formState: { errors, touchedFields },
    control,
    setValue,
    watch,
  } = mainForm;

  const data = watch(fieldName);
  return (
    <div className={`${isLabel ? "mb-3" : ""}`}>
      {isLabel && (
        <Label htmlFor={fieldName}>
          {title || t(`form.${fieldName}`)}{" "}
          {isRequired && <span className="text-danger">*</span>}
        </Label>
      )}
      <Controller
        control={control}
        name={fieldName}
        render={({ field }) => {
          return (
            <HubDeliverySelect
              {...field}
              value={data}
              fieldName={fieldName}
              idDefault={idDefault}
              setValue={setValue}
              isDisabled={isDisabled}
              paramsColumnFilter={paramsColumnFilter}
            />
          );
        }}
      />
      {isError && (
        <MessageFormValidateV2 errors={errors} fieldName={fieldName} />
      )}
    </div>
  );
};

FormHubDeliverySelect.propTypes = {
  mainForm: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isMultiple: PropTypes.bool,
  onChange: PropTypes.func,
  title: PropTypes.string,
  isLabel: PropTypes.bool,
  isError: PropTypes.bool,
  isClearable: PropTypes.bool,
  idDefault: PropTypes.any,
  paramsColumnFilter: PropTypes.object,
};

FormHubDeliverySelect.defaultProps = {
  isDisabled: false,
  isRequired: false,
  isMultiple: false,
  onChange: () => {},
  title: "",
  isLabel: true,
  isError: true,
  isClearable: true,
  paramsColumnFilter: {},
};

export default FormHubDeliverySelect;
